// SeoLinkTagsHelmet.js
'use strict';
import { connect } from 'react-redux';

import SeoLinkTagsHelmet from '../component/SeoLinkTagsHelmet.jsx';
import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  SUPPORTED_LANGUAGES,
  SEO_X_DEFAULT_LANG,
} from '../RemoteConfigKeys.js';

import i18n from '../resource/i18n.js';

const mapStateToProps = (state, { id, isMessage }) => {
  let availableLanguages = getRemoteConfigData(state, SUPPORTED_LANGUAGES);

  if (id) {
    availableLanguages = isMessage
      ? getMessageData(state, id, 'available_languages')
      : getUserData(state, id, 'available_languages');
  }

  return {
    availableLanguages,
    currentLanguage:
      getOperationData(state, ['config'], 'language') || i18n.language,
    xDefaultLanguage: getRemoteConfigData(state, SEO_X_DEFAULT_LANG),
  };
};

export default connect(mapStateToProps, null)(SeoLinkTagsHelmet);
